// extracted by mini-css-extract-plugin
module.exports = {"backToResource":"BackToHandbookIndex_backToResource__31R9v","linkContainer":"BackToHandbookIndex_linkContainer__36JjS","chevron":"BackToHandbookIndex_chevron__2Vov0"};